'use client';

import type { ConversationProposal } from './assistant-state';

const PRIMARY = 'rounded-[9px] bg-[var(--accent)] px-3 py-1.5 text-xs font-bold text-white';
const GHOST = 'rounded-[9px] border border-[var(--ink-200)] bg-[var(--paper)] px-3 py-1.5 text-xs text-[var(--ink-800)]';

interface Props {
  proposal: ConversationProposal;
  onApply: () => void;
  onChange: () => void;
  onDismiss: () => void;
  onRedo: () => void;
}

/** La carte d'une proposition de l'assistant (chantier COP, prototype P02, P03, P05) */
export function AssistantProposal({ proposal, onApply, onChange, onDismiss, onRedo }: Props) {
  const { etat, descriptions, nombre, boutonSupprimer } = proposal;
  if (etat === 'appliquee') {
    return <div role="status" className="flex gap-2 rounded-[10px] border border-green-200 bg-green-50 px-3 py-2.5 text-xs leading-relaxed text-green-800"><span>✓</span><div><b>Appliqué.</b> Ctrl+Z pour l&apos;annuler.</div></div>;
  }
  if (etat === 'ecartee') return <p className="m-0 self-center text-[11px] text-[var(--ink-400)]">Proposition écartée</p>;
  if (etat === 'annulee') {
    return (
      <>
        <p className="m-0 self-center text-[11px] text-[var(--ink-400)]">Action annulée</p>
        <div><button type="button" className={GHOST} onClick={onRedo}>Revoir la proposition</button></div>
      </>
    );
  }
  if (etat === 'perimee') {
    return (
      <>
        <div role="alert" className="flex gap-2 rounded-[10px] border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs leading-relaxed text-amber-900"><span>!</span><div><b>Le plan a changé depuis la proposition.</b> Elle ne s&apos;applique plus telle quelle.</div></div>
        <div><button type="button" className={PRIMARY} onClick={onRedo}>Refaire la proposition</button></div>
      </>
    );
  }
  const label = boutonSupprimer ? 'Supprimer' : nombre > 1 ? `Appliquer les ${nombre} actions` : 'Appliquer';
  return (
    <div className="self-stretch rounded-xl border border-[var(--accent-100)] bg-[var(--accent-50)] px-3 py-2.5">
      <h4 className="m-0 mb-1 text-[12.5px] font-bold text-[var(--accent-700)]">Ce que je vais faire</h4>
      <ul className="m-0 mb-2 list-disc pl-[18px] text-[12.5px] text-[var(--ink-700)]">
        {descriptions.map((d, i) => <li key={i}>{d}</li>)}
      </ul>
      <div className="flex flex-wrap gap-1.5">
        <button type="button" className={PRIMARY} onClick={onApply}>{label}</button>
        <button type="button" className={GHOST} onClick={onChange}>Changer</button>
        <button type="button" className={GHOST} onClick={onDismiss}>Non merci</button>
      </div>
    </div>
  );
}
